<template>
  <Content class="pro-content">
    <Card dis-hover class="content-wrapper">
      <h1 slot="title">{{ $t("apply_for_loan") }}</h1>
      <form @submit="onSubmit" id="apply_for_loan_form">
        <Row :gutter="15">
          <Col :span="12">
          <PFHInput placeholder="Lloji i kredise" label="Zgjedh kredine" name="lloji_kredise" type="select"
            :items="this.kredit" v-model:value="data.lloji_kredise" />
          </Col>
          <Col :span="12">
          <PFHInput placeholder="1000" name="shuma_kredise" label="Shuma e kredisë"
            v-model:value="data.shuma_kredise" />
          </Col>
        </Row>
        <Row :gutter="15">
          <Col :span="12">
          <PFHInput placeholder="p.sh 60 muaj" name="kohezgjatja" label="Kohezgjatja e kredise"
            v-model:value="data.kohezgjatja" />
          </Col>
        </Row>
        <Divider />
        <h2 class="sub-title">{{ $t("Te dhenat mbi aplikuesin") }}</h2>
        <Row :gutter="15">
          <Col :span="12">
          <PFHInput placeholder="Emri" label="Emri" name="emri" v-model:value="data.emri" />
          </Col>
          <Col :span="12">
          <PFHInput placeholder="Mbiemri" label="Mbiemri" name="mbiemri" v-model:value="data.mbiemri" />
          </Col>
        </Row>
        <Row :gutter="15">
          <Col :span="12">
          <PFHInput :placeholder="$t('choose_birthday')" :label="$t('choose_birthday')" type="date"
            name="data_e_lindjes" v-model:value="data.data_e_lindjes" />
          </Col>
          <Col :span="12">
          <PFHInput label="Numri i leternjoftimit tuaj" placeholder="124xxxxxxxx" name="id" v-model:value="data.id" />
          </Col>
        </Row>
        <Row :gutter="15">
          <Col :span="12">
          <PFHInput label="Vendi i lindjes" placeholder="Vendi i lindjes" name="vendi_lindjes"
            v-model:value="data.vendi_lindjes" />
          </Col>
          <Col :span="12">
          <PFHInput label="Adresa juaj aktuale (rruga)*" placeholder="Adresa juaj" name="adresa"
            v-model:value="data.adresa" />
          </Col>
        </Row>
        <Row :gutter="15">
          <Col :span="12">
          <PFHInput label="Adresa juaj dytesore (rruga)" placeholder="Adresa juaj dytesore" name="adresa_dytesore"
            v-model:value="data.adresa_dytesore" />
          </Col>
          <Col :span="12">
          <PFHInput label="Komuna në të cilën jetoni" placeholder="Komuna" type="select" :items="this.komunat"
            name="komuna_ku_jeton" v-model:value="data.komuna_ku_jeton" />
          </Col>
        </Row>
        <Row :gutter="15">
          <Col :span="12">
          <PFHInput label="Komuna në të cilën aplikoni" placeholder="Komuna" type="select" :items="this.komunat"
            name="komuna_ku_aplikon" v-model:value="data.komuna_ku_aplikon" />
          </Col>
          <Col :span="12">
          <PFHInput label="Gjinia" type="radio" :items="this.gjinit" name="gjinia" v-model:value="data.gjinia" />
          </Col>
        </Row>
        <Row :gutter="15">
          <Col :span="12">
          Ngarkoni: ID apo pasaporten (valide), një faturë publike (jo më e vjetër se 6 muaj) dhe kontratën e punës (max
          1MB per fajll)
          <br />
          <input class="ivu-input ivu-input-large file-input" type="file" accept="application/pdf" @change="handleAdd"
            multiple="multiple" max="3" />
          <span v-if="filesError" style="color:hotpink">{{ filesError }}</span>
          </Col>
          <Col :span="12">
          </Col>
        </Row>
        <Divider />
        <h2 class="sub-title">{{ $t("Kontaktet mbi aplikuesin") }}</h2>
        <Row :gutter="15">
          <Col :span="12">
          <PFHInput placeholder="Telefoni" label="Telefoni" name="tel" v-model:value="data.tel" />
          </Col>
          <Col :span="12">
          <PFHInput placeholder="Email" label="Email" name="email" v-model:value="data.email" />
          </Col>
        </Row>

        <Row :gutter="15">
          <Col>
          <CheckboxGroup size="large">
            <Checkbox class="permission" :label="$t('siguroj')" size="large" v-model="siguroj"></Checkbox>
            <Checkbox class="permission" :label="$t('me_shtypje')" size="large" v-model="me_shtypje"></Checkbox>
            <Checkbox class="permission" :label="$t('pajtoj')" size="large" v-model="pajtoj"></Checkbox>
            <Checkbox class="permission" :label="$t('pranoj_email')" size="large" v-model="pranoj_email"></Checkbox>
          </CheckboxGroup>
          </Col>
        </Row>
        <Row :gutter="15" style="margin-top: 40px">
          <Col style="text-align: center">
          <vue-hcaptcha :sitekey="appKey" @verify="onVerify" @challenge-expired="onChallengeExpire" @expired="onExpire"
            @error="onError"></vue-hcaptcha>

          <Button style="max-width: 500px; margin: auto" long type="primary" html-type="submit" size="large"
            :disabled="!(siguroj && me_shtypje && pajtoj && pranoj_email && (isLocal ? true : token) && !filesError && uploadList && uploadList.length)">{{
    $t("apply_for_loan")
            }}</Button>
          </Col>
        </Row>
      </form>
    </Card>
  </Content>
</template>
<style lang="scss">
.pro-content {
  .sub-title {
    // text-align: center;
    padding-bottom: 15px;
  }

  .permission {
    width: 100%;
    padding: 5px 0;

    span:nth-child(2) {
      padding-left: 5px;
    }
  }

  .file-input {
    height: 42px;
  }
}
</style>
<script>
import VueHcaptcha from "@hcaptcha/vue-hcaptcha";
import PFHInput from "@/components/Input.vue";

const localData = {
  "lloji_kredise": "Kredi per vetura",
  "shuma_kredise": "12312",
  "kohezgjatja": "60",
  "emri": "Shpetim",
  "mbiemri": "Selaci",
  "data_e_lindjes": "1999-02-18",
  "id": "12422246236",
  "vendi_lindjes": "Vushtrri",
  "adresa": "Gjergj Kastrioti",
  "adresa_dytesore": "",
  "komuna_ku_jeton": "Vushtrri",
  "komuna_ku_aplikon": "Vushtrri",
  "gjinia": "m",
  "tel": "045343434",
  "email": "shselaci3@gmail.com"
};


export default {
  components: {
    PFHInput,
    VueHcaptcha
  },
  data: function data() {
    return {
      data: process.env.NODE_ENV === 'development' ? localData : {
        lloji_kredise: "",
        shuma_kredise: "",
        kohezgjatja: "",
        emri: "",
        mbiemri: "",
        data_e_lindjes: "",
        id: "",
        vendi_lindjes: "",
        adresa: "",
        adresa_dytesore: "",
        komuna_ku_jeton: "",
        komuna_ku_aplikon: "",
        gjinia: "",
        tel: "",
        email: ""
      },
      filesError: "",
      siguroj: process.env.NODE_ENV === 'development',
      me_shtypje: process.env.NODE_ENV === 'development',
      pajtoj: process.env.NODE_ENV === 'development',
      pranoj_email: process.env.NODE_ENV === 'development',
      verified: false,
      token: "",
      uploadList: [],
      appKey: process.env.VUE_APP_HCAPTCHA_APP_KEY,
      isLocal: process.env.NODE_ENV === 'development',
      error: "",
      gjinit: [{ label: "M", value: "m" }, { label: "F", value: "f" }],
      komunat: [
        {
          label: "Deçan",
          value: "Deçan"
        },
        {
          label: "Dragash",
          value: "Dragash"
        },
        {
          label: "Ferizaj",
          value: "Ferizaj"
        },
        {
          label: "Fushë Kosovë",
          value: "Fushë Kosovë"
        },
        {
          label: "Gjakovë",
          value: "Gjakovë"
        },
        {
          label: "Gjilan",
          value: "Gjilan"
        },
        {
          label: "Gllogoc",
          value: "Gllogoc"
        },
        {
          label: "Graçanicë",
          value: "Graçanicë"
        },
        {
          label: "Hani i Elezit",
          value: "Hani i Elezit"
        },
        {
          label: "Istog",
          value: "Istog"
        },
        {
          label: "Junik",
          value: "Junik"
        },
        {
          label: "Kaçanik",
          value: "Kaçanik"
        },
        {
          label: "Kamenicë",
          value: "Kamenicë"
        },
        {
          label: "Klinë",
          value: "Klinë"
        },
        {
          label: "Kllokot",
          value: "Kllokot"
        },
        {
          label: "Leposaviq",
          value: "Leposaviq"
        },
        {
          label: "Lipjan",
          value: "Lipjan"
        },
        {
          label: "Malishevë",
          value: "Malishevë"
        },
        {
          label: "Mamushë",
          value: "Mamushë"
        },
        {
          label: "Mitrovicë e Jugu",
          value: "Mitrovicë e Jugu"
        },
        {
          label: "Mitrovicë e Veriu",
          value: "Mitrovicë e Veriu"
        },
        {
          label: "Novobërdë",
          value: "Novobërdë"
        },
        {
          label: "Obiliq",
          value: "Obiliq"
        },
        {
          label: "Partesh",
          value: "Partesh"
        },
        {
          label: "Pejë",
          value: "Pejë"
        },
        {
          label: "Podujevë",
          value: "Podujevë"
        },
        {
          label: "Prishtinë",
          value: "Prishtinë"
        },
        {
          label: "Prizren",
          value: "Prizren"
        },
        {
          label: "Rahovec",
          value: "Rahovec"
        },
        {
          label: "Ranillug",
          value: "Ranillug"
        },
        {
          label: "Shtërpcë",
          value: "Shtërpcë"
        },
        {
          label: "Shtime",
          value: "Shtime"
        },
        {
          label: "Skënderaj",
          value: "Skënderaj"
        },
        {
          label: "Suharekë",
          value: "Suharekë"
        },
        {
          label: "Viti",
          value: "Viti"
        },
        {
          label: "Vushtrri",
          value: "Vushtrri"
        },
        {
          label: "Zubin Potok",
          value: "Zubin Potok"
        },
        {
          label: "Zveçan",
          value: "Zveçan"
        }
      ],
      kredit: [
        {
          label: this.$t("cash_loan.menu_title"),
          value: this.$t("cash_loan.menu_title")
        },
        {
          label: this.$t("renovation_loan.menu_title"),
          value: this.$t("renovation_loan.menu_title")
        },
        {
          label: this.$t("car_loan.menu_title"),
          value: this.$t("car_loan.menu_title")
        },
        {
          label: this.$t("mortgage_loan.menu_title"),
          value: this.$t("mortgage_loan.menu_title")
        },
        {
          label: this.$t("goods_financing.menu_title"),
          value: this.$t("goods_financing.menu_title")
        },
        {
          label: this.$t("assets_financing.menu_title"),
          value: this.$t("assets_financing.menu_title")
        },
        {
          label: this.$t("mortgage_financing.menu_title"),
          value: this.$t("mortgage_financing.menu_title")
        },
        {
          label: this.$t("other_finances.menu_title"),
          value: this.$t("other_finances.menu_title")
        }
      ]
    };
  },
  methods: {
    onVerify(token) {
      this.token = token;
    },
    onExpire() {
      this.token = "";
    },
    onChallengeExpire() {
      this.token = "";
    },
    onError(err) {
      this.error = err;
      this.token = "";
    },
    handleAdd(e) {

      this.filesError = "";
      const files = e.target.files;
      console.log(files.length);
      if (files.length !== 3) {
        this.filesError = this.$t(files.length < 3 ? "min_required_files" : "max_required_files");
        return;
      }
      this.uploadList = files
      if (files && files.length) {

        /*Maximum allowed size in bytes
          5MB Example
          Change first operand(multiplier) for your needs*/
        const maxAllowedSize = 1 * 1024 * 1024;
        for (let file of files) {
          if (file.size > maxAllowedSize) {
            this.filesError = this.$t("file_too_big", { filename: file.name });
            break;
          }
        }
      }
    },
    toBase64(fileObj) {
      return new Promise(resolve => {
        var reader = new FileReader();
        // Closure to capture the file information.
        reader.onload = function (e) {
          let binaryData = e.target.result;
          //Converting Binary Data to base 64
          let base64String = window.btoa(binaryData);
          //showing file converted to base64
          resolve(base64String)
        };
        // Read in the image file as a data URL.
        reader.readAsBinaryString(fileObj);
      })


    },


    async getFilesAsBase64(files) {
      let filesAsBase64 = [];
      for (let file of files) {
        filesAsBase64.push(new Promise(async resolve => {
          const content = await this.toBase64(file);
          resolve({
            name: file.name,
            content,
          })
        }))
      }
      return await Promise.all(filesAsBase64);
    },

    async onSubmit(e) {
      e.preventDefault();
      e.stopPropagation();
      const formData = new FormData();
      console.log(this.data);
      Object.keys(this.data).forEach((key) => {
        formData.append(key, this.data[key]);
      });

      console.log(this.uploadList)
      const files = await this.getFilesAsBase64(this.uploadList);

      files.forEach((file, index) => {
        formData.append(`file[${index}].name`, file.name);
        formData.append(`file[${index}].content`, file.content);
      })
      const endpoint = process.env.NODE_ENV === "development" ? "http://localhost/api" : process.env.VUE_APP_STRAPI_API;
      await fetch(`${endpoint}/loan-application`, {
        method: "POST",

        headers: {
          Authorization: this.token,
        },
        body: formData,
      });

      this.token = "";

      this.$router.replace("/application-success");
    }
  }
};
</script>
